import { render, staticRenderFns } from "./task_add.vue?vue&type=template&id=451e1c88&scoped=true"
import script from "./task_add.vue?vue&type=script&lang=js"
export * from "./task_add.vue?vue&type=script&lang=js"
import style0 from "./task_add.vue?vue&type=style&index=0&id=451e1c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451e1c88",
  null
  
)

export default component.exports